/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ action: NonNullable<unknown>, years: NonNullable<unknown> }} Tld_Pricing_Cost_LabelInputs */

const id_tld_pricing_cost_label = /** @type {(inputs: Tld_Pricing_Cost_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.action} ${i?.years} tahun`)
};

const en_tld_pricing_cost_label = /** @type {(inputs: Tld_Pricing_Cost_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.action}, ${i?.years} yr`)
};

/**
* | output |
* | --- |
* | "{action}, {years} yr" |
*
* @param {Tld_Pricing_Cost_LabelInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_cost_label = /** @type {((inputs: Tld_Pricing_Cost_LabelInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Cost_LabelInputs, { locale?: "id" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_cost_label(inputs)
	return id_tld_pricing_cost_label(inputs)
});